
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/**
 * Block size
 */ const $a718c44dd6b9fea5$export$b2e3d6d444266a5c = 20;
const $a718c44dd6b9fea5$export$496699d90bec4375 = 28;
const $a718c44dd6b9fea5$export$d9d362ec8c91a285 = 15;
const $a718c44dd6b9fea5$export$7385d401014409ab = {
    ARROW_RIGHT: "ArrowRight",
    ARROW_LEFT: "ArrowLeft",
    ARROW_UP: "ArrowUp",
    ARROW_DOWN: "ArrowDown"
};
const $a718c44dd6b9fea5$export$e3391822ae2673b5 = [
    {
        color: "#ff0127",
        shape: [
            [
                1,
                0,
                0
            ],
            [
                1,
                1,
                1
            ],
            [
                0,
                0,
                0
            ]
        ]
    },
    {
        color: "#edebe9",
        shape: [
            [
                0,
                0,
                0,
                0
            ],
            [
                2,
                2,
                2,
                2
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ]
    },
    {
        color: "#fbce05",
        shape: [
            [
                3,
                3
            ],
            [
                3,
                3
            ]
        ]
    },
    {
        color: "#43d562",
        shape: [
            [
                4,
                4,
                0
            ],
            [
                0,
                4,
                4
            ],
            [
                0,
                0,
                0
            ]
        ]
    },
    {
        color: "#a469b6",
        shape: [
            [
                0,
                5,
                0
            ],
            [
                5,
                5,
                5
            ],
            [
                0,
                0,
                0
            ]
        ]
    },
    {
        color: "#FF8C00",
        shape: [
            [
                0,
                0,
                6
            ],
            [
                6,
                6,
                6
            ],
            [
                0,
                0,
                0
            ]
        ]
    },
    {
        color: "#3c77b5",
        shape: [
            [
                0,
                7,
                7
            ],
            [
                7,
                7,
                0
            ],
            [
                0,
                0,
                0
            ]
        ]
    }
];
const $a718c44dd6b9fea5$export$fdaad3aec806b2b4 = 10;
const $a718c44dd6b9fea5$export$e83671fde4214b16 = 100;
const $a718c44dd6b9fea5$export$db44128aabfe0552 = [
    600,
    500,
    450,
    400,
    350,
    300,
    250,
    200,
    150,
    100
];
const $a718c44dd6b9fea5$export$fa243cdab3e4d35b = {
    UP: 0,
    RIGHT: 1,
    DOWN: 2,
    LEFT: 3
};


class $c98166642368022c$export$5e17e8ad324a9581 {
    constructor(ctx){
        /**
   * Represents the game board.
   */ this.board = [
            []
        ];
        this.ctx = ctx;
        this.init();
    }
    /**
   * Init the game board.
   */ init() {
        this.ctx.canvas.width = (0, $a718c44dd6b9fea5$export$d9d362ec8c91a285) * (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c);
        this.ctx.canvas.height = (0, $a718c44dd6b9fea5$export$496699d90bec4375) * (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c);
    // FIXME: this.ctx.scale(BLOCK_SIZE, BLOCK_SIZE);
    }
    /**
   * Draw the game board and all the tetrominoes in it.
   */ draw() {
        for(let y = 0; y < (0, $a718c44dd6b9fea5$export$496699d90bec4375); y++)for(let x = 0; x < (0, $a718c44dd6b9fea5$export$d9d362ec8c91a285); x++){
            const value = this.board[y][x];
            if (value > 0) {
                const t = (0, $a718c44dd6b9fea5$export$e3391822ae2673b5)[value - 1];
                this.ctx.fillStyle = t.color;
                this.ctx.fillRect(x * (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c), y * (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c), (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c) - 2, (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c) - 2);
            // FIXME this.ctx.strokeRect(x * BLOCK_SIZE, y * CELL_SIZE, 28, 28);
            }
        }
    }
    /**
   * Clear full line.
   * If we have a full row, we need to erase it and shift all rows from the top.
   *
   * @returns the number of lines cleared.
   */ clearLine() {
        let lines = 0;
        for(let row = 0; row < (0, $a718c44dd6b9fea5$export$496699d90bec4375); row++)if (this.board[row].every((value)=>value > 0)) {
            lines++;
            // Remove the row.
            this.board.splice(row, 1);
            // Add row at the top.
            this.board.unshift(Array((0, $a718c44dd6b9fea5$export$d9d362ec8c91a285)).fill(0));
        }
        return lines;
    }
    /**
   * Check if the future position of the Tetromino is valid.
   *
   * @param tetromino - The Tetromino.
   * @param translationCoord - x and y to add to the tetrimino points (translation operation)
   *
   * @returns True if the next position is valid then False.
   */ isValid(tetromino) {
        for(let y = 0, rows = tetromino.shape.length; y < rows; y++)for(let x = 0, cols = tetromino.shape[0].length; x < cols; x++){
            const XCoordinate = tetromino.x + x;
            const YCoordinate = tetromino.y + y;
            // It's not a real part of our Tetrimino, so we ignore it.
            if (tetromino.shape[y][x] === 0) continue;
            // Check that we are inside the game board.
            if (XCoordinate < 0 || XCoordinate >= (0, $a718c44dd6b9fea5$export$d9d362ec8c91a285) || YCoordinate >= (0, $a718c44dd6b9fea5$export$496699d90bec4375)) return false;
            // Check that we are not overlapping another Tetromino.
            if (this.board[YCoordinate] && this.board[YCoordinate][XCoordinate]) return false;
        }
        return true;
    }
    /**
   * Save the tetromino in the board (final position).
   *
   * @param tetromino - Tetromino to insert.
   */ save(tetromino) {
        for(let y = 0, row = tetromino.shape.length; y < row; y++)for(let x = 0, col = tetromino.shape[0].length; x < col; x++){
            const XCoordinate = tetromino.x + x;
            const YCoordinate = tetromino.y + y;
            if (tetromino.shape[y][x] > 0) this.board[YCoordinate][XCoordinate] = tetromino.shape[y][x];
        }
    }
    /**
   * Reset the board to an empty board.
   */ setEmptyBoard() {
        this.board = Array.from({
            length: (0, $a718c44dd6b9fea5$export$496699d90bec4375)
        }, ()=>Array((0, $a718c44dd6b9fea5$export$d9d362ec8c91a285)).fill(0));
    }
}




class $034c28c78c49cec9$export$ca664994d1d54bff {
    constructor(){
        this.value = 1;
        this.speedInMs = 600;
    }
    /**
   * Get the level from the score.
   *
   * @param score - The score.
   *
   * @returns the new level.
   */ getLevelFromScore(score) {
        return Math.floor(score / 1000) + 1;
    }
    /**
   * Update and display the level if necessary.
   *
   * @param score - The score.
   */ updateLevel(score) {
        if (this.value < (0, $a718c44dd6b9fea5$export$fdaad3aec806b2b4)) {
            const level = this.getLevelFromScore(score);
            if (level !== this.value) {
                this.value = level;
                this.speedInMs = (0, $a718c44dd6b9fea5$export$db44128aabfe0552)[this.value - 1];
            }
        }
    }
}



class $ffabdd64324d7a97$export$895ce1c59e172b74 {
    constructor(ctx){
        this.ctx = ctx;
    }
    /**
   * Create a random tetromino.
   *
   * @param ctx - Canvas Context 2D.
   *
   * @returns a Tetromino.
   */ static createRandomTetromino(ctx) {
        const index = Math.floor(Math.random() * (0, $a718c44dd6b9fea5$export$e3391822ae2673b5).length);
        const t = (0, $a718c44dd6b9fea5$export$e3391822ae2673b5)[index];
        const tetromino = new $ffabdd64324d7a97$export$895ce1c59e172b74(ctx);
        if (t) {
            tetromino.y = 0;
            tetromino.color = t.color;
            tetromino.shape = t.shape;
            // Center the tetromino in the game board.
            tetromino.x = Math.floor(((0, $a718c44dd6b9fea5$export$d9d362ec8c91a285) - t.shape.length) / 2);
        } else console.error("No tetrimino available for index", index);
        return tetromino;
    }
    /**
   * Clone Tetromino.
   *
   * @returns a new instance of the Tetromino.
   */ clone() {
        const tetromino = new $ffabdd64324d7a97$export$895ce1c59e172b74(this.ctx);
        tetromino.x = this.x;
        tetromino.y = this.y;
        tetromino.color = this.color;
        // Deep copy
        tetromino.shape = JSON.parse(JSON.stringify(this.shape));
        return tetromino;
    }
    /**
   * Move down.
   */ moveDown() {
        this.y += 1;
    }
    /**
   * Move left.
   */ moveLeft() {
        this.x -= 1;
    }
    /**
   * Move right.
   */ moveRight() {
        this.x += 1;
    }
    /**
   * Rotation.
   *┌─────────┬───┬───┬───┐     ┌─────────┬───┬───┬───┐
   *│ (index) │ 0 │ 1 │ 2 │     │ (index) │ 0 │ 1 │ 2 │
   *├─────────┼───┼───┼───┤     ├─────────┼───┼───┼───┤
   *│    0    │ 1 │ 0 │ 0 │  →  │    0    │ 0 │ 1 │ 0 │
   *│    1    │ 1 │ 1 │ 1 │     │    1    │ 0 │ 1 │ 0 │
   *│    2    │ 0 │ 0 │ 0 │     │    2    │ 1 │ 1 │ 0 │
   *└─────────┴───┴───┴───┘     └─────────┴───┴───┴───┘
   *
   */ rotate() {
        const len = this.shape.length;
        // Transpose matrix.
        for(let y = 0, rows = len; y < rows; y++)for(let x = 0; x < y; x++)[this.shape[y][x], this.shape[x][y]] = [
            this.shape[x][y],
            this.shape[y][x]
        ];
        // Reverse rows.
        for(let i = 0; i < len; i++)this.shape = this.shape.reverse();
    }
    /**
   * Draw the tetromino in the Canvas
   */ draw() {
        this.ctx.fillStyle = this.color;
        for(let y = 0; y < this.shape.length; y++){
            for(let x = 0; x < this.shape[0].length; x++)if (this.shape[y][x] > 0) this.ctx.fillRect(x * (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c) + this.x * (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c), y * (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c) + this.y * (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c), (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c) - 2, (0, $a718c44dd6b9fea5$export$b2e3d6d444266a5c) - 2);
        }
    }
    drawPreview() {
        this.ctx.fillStyle = this.color;
        const BLOCK = 18;
        for(let y = 0; y < this.shape.length; y++){
            for(let x = 0; x < this.shape[0].length; x++)if (this.shape[y][x] > 0) this.ctx.fillRect(BLOCK * x + (this.ctx.canvas.width - this.shape.length * BLOCK) / 2, BLOCK * y + (this.ctx.canvas.height - 2 * BLOCK) / 2, BLOCK - 2, BLOCK - 2);
        }
    }
    /**
   * Set Canvas Context 2D.
   */ setContext(ctx) {
        this.ctx = ctx;
    }
}


var $35b05d22fc6ae9da$exports = {};
var $8ab617456a9f26ae$exports = {};
$8ab617456a9f26ae$exports = import.meta.resolve("ido6V");


var $15fb4855da0538c8$exports = {};
$15fb4855da0538c8$exports = import.meta.resolve("5HXlI");


var $ee2b33d08dadf2ae$exports = {};
$ee2b33d08dadf2ae$exports = import.meta.resolve("8nRBd");


var $a2a49ff437e9b120$exports = {};
$a2a49ff437e9b120$exports = import.meta.resolve("k2bG4");


var $7df8b4b104a68a05$exports = {};
$7df8b4b104a68a05$exports = import.meta.resolve("cE9bK");


var $041741a32c6e1a03$exports = {};
$041741a32c6e1a03$exports = import.meta.resolve("91F8p");


var $90455276e612cfab$exports = {};
$90455276e612cfab$exports = import.meta.resolve("26hLo");


$35b05d22fc6ae9da$exports = {
    "4-lines": $8ab617456a9f26ae$exports,
    "game-over": $15fb4855da0538c8$exports,
    "landed": $ee2b33d08dadf2ae$exports,
    "line-clear": $a2a49ff437e9b120$exports,
    "move": $7df8b4b104a68a05$exports,
    "rotate": $041741a32c6e1a03$exports,
    "theme": $90455276e612cfab$exports
};




class $20094b639d5d7ee9$export$76eeb3aae76ab221 {
    constructor(){
        this.muted = false;
        this.sounds = {};
        for(let key in 0, (/*@__PURE__*/$parcel$interopDefault($35b05d22fc6ae9da$exports)))this.sounds[key] = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($35b05d22fc6ae9da$exports)))[key]);
        this.button = document.querySelector("#sound");
        this.button.addEventListener("click", this.toggleSound.bind(this));
    }
    play(name) {
        this.sounds[name].play();
    }
    /**
   * Init and play the theme music.
   */ start() {
        for(let sound in this.sounds)this.sounds[sound].volume = 0.3;
        this.sounds["theme"].loop = true;
        this.sounds["theme"].volume = 0.1;
        this.sounds["theme"].play();
    }
    /**
   * Stop the main music (theme).
   */ stop() {
        const themeMusic = this.sounds["theme"];
        themeMusic.pause();
        themeMusic.currentTime = 0;
    }
    /**
   * Toggle state sound.
   */ toggleSound() {
        this.muted = !this.muted;
        for(let sound in this.sounds)this.sounds[sound].muted = this.muted;
        // Replace the image about sound.
        this.button.innerHTML = this.muted ? `<img src="${0, {}}" />` : `<img src="${0, {}}" />`;
    }
}


class $e1ffbecaf7381bc8$export$985739bfa5723e08 {
    constructor(ctx, ctxNextTetromino, scoreHTMLElement, levelHTMLElement, gamepadHTMLElements){
        /**
   * The ID value returned by window.requestAnimationFrame.
   * We need this to cancel requestAnimationFrame if the player launches another game.
   */ this.requestId = 0;
        /**
   * Mapping of keyboard events.
   */ this.moves = {
            [(0, $a718c44dd6b9fea5$export$7385d401014409ab).ARROW_DOWN]: (t)=>t.moveDown(),
            [(0, $a718c44dd6b9fea5$export$7385d401014409ab).ARROW_LEFT]: (t)=>t.moveLeft(),
            [(0, $a718c44dd6b9fea5$export$7385d401014409ab).ARROW_RIGHT]: (t)=>t.moveRight(),
            [(0, $a718c44dd6b9fea5$export$7385d401014409ab).ARROW_UP]: (t)=>{
                this.sound.play("rotate");
                t.rotate();
            }
        };
        this.ctx = ctx;
        this.scoreHTMLElement = scoreHTMLElement;
        this.levelHTMLElement = levelHTMLElement;
        // Set canvas that render the next Tetromino.
        this.ctxNextTetromino = ctxNextTetromino;
        this.ctxNextTetromino.canvas.width = 80;
        this.ctxNextTetromino.canvas.height = 40;
        // Set the sound.
        this.sound = new (0, $20094b639d5d7ee9$export$76eeb3aae76ab221)();
        // Init and draw an empty board.
        this.board = new (0, $c98166642368022c$export$5e17e8ad324a9581)(this.ctx);
        // Set and display the score.
        this.score = 0;
        this.updateUi(this.scoreHTMLElement, this.score);
        // Init the level.
        this.level = new (0, $034c28c78c49cec9$export$ca664994d1d54bff)();
        this.updateUi(this.levelHTMLElement, this.level.value);
        // Set the gamepad element.
        this.gamepadHTMLElements = gamepadHTMLElements;
        this.handleGamepad = this.handleGamepad.bind(this);
        this.handleKeyboard = this.handleKeyboard.bind(this);
        this.welcome();
    }
    /**
   * Display welcome screen.
   */ welcome() {
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.fillStyle = "white";
        this.ctx.font = "70px VT323";
        let text = "Tetris";
        let measureText = this.ctx.measureText(text);
        // this.ctx.fillText(text, 114, 80);
        this.ctx.fillText(text, (this.ctx.canvas.width - measureText.width) / 2, 100);
        this.ctx.fillStyle = "#708552";
        this.ctx.font = "40px VT323";
        text = "Jouer";
        measureText = this.ctx.measureText(text);
        this.ctx.fillRect((this.ctx.canvas.width - measureText.width - 100) / 2, (this.ctx.canvas.height - measureText.actualBoundingBoxAscent) / 2 - 40, measureText.width + 100, 60);
        this.ctx.fillStyle = "white";
        this.ctx.fillText(text, (this.ctx.canvas.width - measureText.width) / 2, (this.ctx.canvas.height - measureText.actualBoundingBoxAscent) / 2);
    }
    /**
   * Reset the game.
   */ reset() {
        // Reset level.
        this.level = new (0, $034c28c78c49cec9$export$ca664994d1d54bff)();
        // Reset score.
        this.score = 0;
        this.updateUi(this.scoreHTMLElement, this.score);
        // Init and play the theme music.
        this.sound.start();
        // Remove previous listeners
        removeEventListener("keydown", this.handleKeyboard);
        this.removeGamepadEventListener();
        // If we still have a running game.
        if (this.requestId) {
            cancelAnimationFrame(this.requestId);
            this.requestId = 0;
        }
        // Reset the game board.
        this.board.setEmptyBoard();
    }
    /**
   * Start a new game.
   */ start() {
        this.reset();
        // Create the tetromino (the one that falls from the sky)
        this.tetromino = (0, $ffabdd64324d7a97$export$895ce1c59e172b74).createRandomTetromino(this.ctx);
        // Create the next tetromino.
        this.nextTetromino = (0, $ffabdd64324d7a97$export$895ce1c59e172b74).createRandomTetromino(this.ctxNextTetromino);
        // Draw the next Tetromino.
        this.nextTetromino.draw();
        // Add event listener for keyboard.
        addEventListener("keydown", this.handleKeyboard);
        // Add event listener for the gamepad.
        this.addGamepadEventListener();
        // Launch the game animation.
        this.time = performance.now();
        // Launch the animation game.
        this.animate(this.time);
    }
    /**
   * Game over.
   */ gameOver() {
        this.reset();
        // Stop the main music.
        this.sound.stop();
        // Play the game over sound.
        this.sound.play("game-over");
        this.ctx.fillStyle = "black";
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.fillStyle = "red";
        this.ctx.font = "30px serif";
        const text = "Game over!";
        const measureText = this.ctx.measureText(text);
        this.ctx.fillText(text, (this.ctx.canvas.width - measureText.width) / 2, (this.ctx.canvas.height - measureText.actualBoundingBoxAscent) / 2);
    }
    /**
   * Animate the game.
   */ animate(now) {
        const timelapsed = now - this.time;
        if (!timelapsed || timelapsed > this.level.speedInMs) {
            // Duplicate the tetromino.
            let tetromino = this.tetromino.clone();
            // Apply the movement on the cloned tetromino.
            this.moves[(0, $a718c44dd6b9fea5$export$7385d401014409ab).ARROW_DOWN](tetromino);
            if (this.board.isValid(tetromino)) this.tetromino = tetromino; // keep the Tetromino with the last position.
            else {
                if (this.tetromino.y <= 0) {
                    this.gameOver();
                    return;
                }
                // Save the final position of the tetromino in the board.
                this.board.save(this.tetromino);
                this.sound.play("landed");
                // Clear full line(s).
                let lines = this.board.clearLine();
                // Compute and update the score.
                if (lines > 0) {
                    if (lines === 4) this.sound.play("4-lines");
                    else this.sound.play("line-clear");
                    this.updateScore(lines);
                    this.updateUi(this.scoreHTMLElement, this.score);
                    // Update and display the level.
                    this.level.updateLevel(this.score);
                    this.updateUi(this.levelHTMLElement, this.level.value);
                }
                // Set the current Tetromino.
                this.tetromino = this.nextTetromino;
                this.tetromino.setContext(this.ctx);
                // Generate the next Tetromino.
                this.nextTetromino = (0, $ffabdd64324d7a97$export$895ce1c59e172b74).createRandomTetromino(this.ctxNextTetromino);
            }
            this.time = performance.now();
        }
        // Clears the game board canvas before drawing the next frame.
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        // Clears the next Tetromino canvas before drawing the next frame.
        this.ctxNextTetromino.clearRect(0, 0, this.ctxNextTetromino.canvas.width, this.ctxNextTetromino.canvas.height);
        // Draw the game board and all the tetrominoes in it.
        this.board.draw();
        // Draw the tetromino (the one that falls from the sky)
        this.tetromino.draw();
        // Draw the next Tetromino.
        this.nextTetromino.drawPreview();
        this.requestId = window.requestAnimationFrame(this.animate.bind(this));
    }
    /**
   * Check if the game is running.
   *
   * @returns True if the game is running else False.
   */ isRunning() {
        return this.requestId !== 0;
    }
    /**
   * Compute and update the score from lines.
   *
   * @param score - The score.
   */ updateScore(lines) {
        this.score += lines * (0, $a718c44dd6b9fea5$export$e83671fde4214b16) * this.level.value;
    }
    /**
   * Update user interface.
   *
   * @param htmlElement - The htmlElement.
   * @param newValue - The new value.
   *
   * @returns the score for the lines cleared
   *
   */ updateUi(htmlElement, newValue) {
        if (htmlElement.innerHTML != newValue.toString()) htmlElement.innerHTML = newValue.toString();
    }
    /**
   * Add gamepad event listener.
   */ addGamepadEventListener() {
        for(let i = 0; i < this.gamepadHTMLElements.length; i++)this.gamepadHTMLElements[i].addEventListener("mousedown", this.handleGamepad);
    }
    /**
   * Remove gamepad event listener.
   */ removeGamepadEventListener() {
        for(let i = 0; i < this.gamepadHTMLElements.length; i++)this.gamepadHTMLElements[i].removeEventListener("mousedown", this.handleGamepad);
    }
    /**
   * Try to move or rotate the tetromino.
   * Event comes from keyboard and the gamepad (ui).
   *
   * @param keyboardKey - The keyboard key.
   */ tryToMove(keyboardKey) {
        const move = this.moves[keyboardKey];
        if (move) {
            // Duplicate the tetromino.
            let tetromino = this.tetromino.clone();
            // Apply the movement on the cloned tetromino.
            move(tetromino);
            if (this.board.isValid(tetromino)) {
                this.sound.play("move");
                this.tetromino = tetromino;
            }
        }
    }
    /**
   * Handle keyboard events.
   */ handleKeyboard(event) {
        event.preventDefault();
        this.tryToMove(event.code);
    }
    /**
   * Handle gamepad events.
   */ handleGamepad(event) {
        event.preventDefault();
        this.tryToMove(event.currentTarget.name);
    }
}


/**
 * Get all HTML elements.
 */ const $fa9f30b640a9bba9$var$boardGame = document.querySelector("#board-game");
const $fa9f30b640a9bba9$var$nextTetromino = document.querySelector("#next-tetromino");
const $fa9f30b640a9bba9$var$scoreHTMLElement = document.querySelector("#score");
const $fa9f30b640a9bba9$var$levelHTMLElement = document.querySelector("#level");
const $fa9f30b640a9bba9$var$gamepadHTMLElements = document.querySelectorAll("div#gamepad button");
if ($fa9f30b640a9bba9$var$boardGame && $fa9f30b640a9bba9$var$nextTetromino) {
    const ctxBoard = $fa9f30b640a9bba9$var$boardGame.getContext("2d");
    const ctxNextTetromino = $fa9f30b640a9bba9$var$nextTetromino.getContext("2d");
    if (ctxBoard && ctxNextTetromino && $fa9f30b640a9bba9$var$levelHTMLElement) {
        // Init the game.
        const game = new (0, $e1ffbecaf7381bc8$export$985739bfa5723e08)(ctxBoard, ctxNextTetromino, $fa9f30b640a9bba9$var$scoreHTMLElement, $fa9f30b640a9bba9$var$levelHTMLElement, $fa9f30b640a9bba9$var$gamepadHTMLElements);
        // Start the game.
        $fa9f30b640a9bba9$var$boardGame.addEventListener("click", ()=>{
            if (game.isRunning()) return;
            game.start();
        });
    }
}


//# sourceMappingURL=path0.6bae667f.js.map
